import { createContext, useContext } from 'react';

/**
 * Holds the id of the edge currently being reconnected (between
 * onReconnectStart and onReconnectEnd). NulaConnectionLine reads this
 * so its in-flight rubber-band line can mirror the user-edited stroke
 * / width / style / curvature of the actual edge instead of a generic
 * default.
 *
 * A ref (not state) by design — RF doesn't re-render on connection
 * pointer moves, so a setter would re-render every consumer; a ref
 * stays cheap and the connection-line component already re-renders
 * from RF's own internal pointer updates.
 */
export interface InFlightReconnectRef {
  current: string | null;
}

export const InFlightReconnectContext = createContext<InFlightReconnectRef | null>(null);

export function useInFlightReconnectRef(): InFlightReconnectRef | null {
  return useContext(InFlightReconnectContext);
}
